module.exports = __webpack_public_path__ + "static/media/certyfikat-23.fc1c0604.png";